import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ResetPasswordPage } from '@/features/auth/reset-password-page';

/**
 * Токен приходить у посиланні з листа: бекенд перевіряє його й редіректить
 * сюди з `?token=...`. Без токена форму показувати немає сенсу — саме тому
 * він у схемі, а не читається з `window.location` десь усередині компонента.
 */
const resetPasswordSearchSchema = z.object({
	token: z.string().min(1).optional(),
});

export const Route = createFileRoute('/reset-password')({
	validateSearch: resetPasswordSearchSchema,
	component: ResetPasswordPage,
	staticData: { fullScreen: true },
});
